import React, {Component} from 'react'

class StatusBadge extends Component {
  render() {
    return (
      <span style={{minWidth: 70+'px'}} className={`badge badge-sm badge-${this.props.status} badge-outline`}>{this.props.statusLabel}</span>
    )
  }
}

export default StatusBadge